import { freeScreenScope } from "src/configs/subscription-access";
import { backend } from "src/api";

class AptApi {
  async getAbygAptsByRegionIds(request) {
    const response = await backend.post(`/apts/abygs/filter`, request);
    return response.data;
  }

  async getAbygAptsByFrom(request) {
    const response = await backend.post("/apts/abyg", request);
    return response.data;
  }

  async getSPyeongsRealPrices(request) {
    const response = await backend.post(freeScreenScope() === "apartment" ? `/free/apartments/${new URLSearchParams(window.location.search).get("id")}/sp-realprices` : `/apts/spyeongs/realprices`, request);
    return response.data;
  }

  async getEPyeongsRealPrices(request) {
    const response = await backend.post(freeScreenScope() === "apartment" ? `/free/apartments/${new URLSearchParams(window.location.search).get("id")}/ep-realprices` : `/apts/epyeongs/realprices`, request);
    return response.data;
  }

  async getAptMes(aptId) {
    const response = await backend.get(`/apts/${aptId}/pyeongs/mes`);
    return response.data;
  }

  /** 공급평형 기준 같은 단지 평형저평가 비교 결과를 조회한다. */
  async getSPyeongSizeUndervalue(pyeongId, params = {}) {
    const response = await backend.get(`/apts/spyeongs/${pyeongId}/size-undervalue`, {
      params,
    });
    return response.data;
  }

  /** 공급평형 기준 과거 동일 가격대 가격저평가 비교 결과를 조회한다. */
  async getSPyeongPriceUndervalue(pyeongId, params = {}) {
    const response = await backend.get(`/apts/spyeongs/${pyeongId}/price-undervalue`, {
      params,
    });
    return response.data;
  }

  /** 공급평형 기준 대상·인근 군구 흐름저평가 저장 결과를 조회한다. */
  async getSPyeongFlowUndervalue(pyeongId) {
    const response = await backend.get(`/apts/spyeongs/${pyeongId}/flow-undervalue`);
    return response.data;
  }

  /** 군구 평당가 분포 기반 상승여력 상세를 조회한다. */
  async getSPyeongUpside(pyeongId, binUnit = 100, scope = "GUNGU") {
    const response = await backend.get(`/apts/spyeongs/${pyeongId}/upside`, {
      params: { binUnit, scope },
    });
    return response.data;
  }

  /** 공급평형 기준 급매 비교 결과를 조회한다. */
  async getSPyeongBargain(pyeongId, params = {}) {
    const response = await backend.get(`/apts/spyeongs/${pyeongId}/bargain`, {
      params,
    });
    return response.data;
  }

  /** 지역/필터 조건에 맞는 같은 단지 평형저평가 공급평형 목록을 조회한다. */
  async getSPyeongSizeUndervalueList(request, pageable) {
    const { filters, page, rowsPerPage, sortBy, sortDir } = pageable;
    const params = {
      search: filters?.search,
      page,
      size: rowsPerPage,
      sort: sortBy && sortDir ? `${sortBy},${sortDir}` : undefined,
    };
    const response = await backend.post("/apts/spyeongs/size-undervalue", request, {
      params,
    });
    return response.data;
  }

  /** 지역/필터 조건에 맞는 가격저평가 공급평형 목록을 조회한다. */
  async getSPyeongPriceUndervalueList(request, pageable) {
    const { filters, page, rowsPerPage, sortBy, sortDir } = pageable;
    const params = {
      search: filters?.search,
      page,
      size: rowsPerPage,
      sort: sortBy && sortDir ? `${sortBy},${sortDir}` : undefined,
    };
    const response = await backend.post("/apts/spyeongs/price-undervalue", request, {
      params,
    });
    return response.data;
  }

  /** 지역/필터 조건에 맞는 흐름저평가 공급평형 목록을 조회한다. */
  async getSPyeongFlowUndervalueList(request, pageable) {
    const { filters, page, rowsPerPage, sortBy, sortDir } = pageable;
    const params = {
      search: filters?.search,
      page,
      size: rowsPerPage,
      sort: sortBy && sortDir ? `${sortBy},${sortDir}` : undefined,
    };
    const response = await backend.post("/apts/spyeongs/flow-undervalue", request, { params });
    return response.data;
  }

  /** 지역/필터 조건에 맞는 상승여력 공급평형 목록을 조회한다. */
  async getSPyeongUpsideList(request, pageable, scope = "GUNGU") {
    const { filters, page, rowsPerPage, sortBy, sortDir } = pageable;
    const params = {
      search: filters?.search,
      page,
      size: rowsPerPage,
      sort: sortBy && sortDir ? `${sortBy},${sortDir}` : undefined,
      scope,
    };
    const response = await backend.post("/apts/spyeongs/upside", request, { params });
    return response.data;
  }

  /** 지역/필터 조건에 맞는 급매 공급평형 목록을 조회한다. */
  async getSPyeongBargainList(request, pageable) {
    const { filters, page, rowsPerPage, sortBy, sortDir } = pageable;
    const params = {
      search: filters?.search,
      page,
      size: rowsPerPage,
      sort: sortBy && sortDir ? `${sortBy},${sortDir}` : undefined,
    };
    const response = await backend.post("/apts/spyeongs/bargain", request, {
      params,
    });
    return response.data;
  }

  async getAptCInfo(aptId) {
    const response = await backend.get(`/apts/${aptId}/cinfo`);
    return response.data;
  }

  async getPyeongsCInfo(aptId) {
    const response = await backend.get(`/apts/${aptId}/pyeongs/cinfo`);
    return response.data;
  }

  async getRegionApts(request) {
    const response = await backend.post("/apts/regions", request);
    return response.data;
  }

  async getMoveInApts(request) {
    const response = await backend.post("/apts/movein", request);
    return response.data;
  }

  /** 월간현황 동 입주물량을 구성하는 제한 없는 아파트 목록을 조회한다. */
  async getMoveInDrilldownApts(request) {
    const response = await backend.post("/apts/movein/drilldown", request);
    return response.data;
  }

  async getPyeongSummary(request) {
    const response = await backend.post("/apts/pyeongs/summary", request);
    return response.data;
  }

  async getSelectedInfo(request) {
    const response = await backend.post("/apts/selected", request);
    return response.data;
  }

  async getSelectPyeongInfo(request) {
    const response = await backend.post("/apts/pyeong/select", request);
    return response.data;
  }

  async getSelectAptInfo(request, pageable) {
    const { filters, page, rowsPerPage, sortBy, sortDir } = pageable;
    const params = {
      search: filters.search,
      page,
      size: rowsPerPage,
      sort: sortBy && sortDir ? `${sortBy},${sortDir}` : undefined,
    };
    const response = await backend.post("/apts/select", request, {
      params,
    });
    return response.data;
  }

  async getPriceGrades(params) {
    const response = await backend.get("/apts/price-grades", { params });
    return response.data;
  }

  async getSelectAptMapInfo(request, pageable) {
    const { filters, page, rowsPerPage, sortBy, sortDir } = pageable;
    const params = {
      search: filters.search,
      page,
      size: rowsPerPage,
      sort: sortBy && sortDir ? `${sortBy},${sortDir}` : undefined,
    };
    const response = await backend.post("/apts/select/map", request, {
      params,
    });
    return response.data;
  }

  async getSelectAptInfoPerRegion(request, pageable) {
    const { filters, page, rowsPerPage, sortBy, sortDir } = pageable;
    const params = {
      search: filters.search,
      page,
      size: rowsPerPage,
      sort: sortBy && sortDir ? `${sortBy},${sortDir}` : undefined,
    };
    const response = await backend.post("/apts/select/perregion", request, {
      params,
    });
    return response.data;
  }

  async getSelectMainPyeongInfo(request, pageable) {
    const { filters, page, rowsPerPage, sortBy, sortDir } = pageable;
    const params = {
      search: filters.search,
      page,
      size: rowsPerPage,
      sort: sortBy && sortDir ? `${sortBy},${sortDir}` : undefined,
    };
    const response = await backend.post("/apts/mp/select", request, {
      params,
    });
    return response.data;
  }

  async getSelectMainPyeongMapInfo(request, pageable) {
    const { filters, page, rowsPerPage, sortBy, sortDir } = pageable;
    const params = {
      search: filters.search,
      page,
      size: rowsPerPage,
      sort: sortBy && sortDir ? `${sortBy},${sortDir}` : undefined,
    };
    const response = await backend.post("/apts/mp/select/map", request, {
      params,
    });
    return response.data;
  }

  async getSelectMainPyeongInfoPerRegion(request, pageable) {
    const { filters, page, rowsPerPage, sortBy, sortDir } = pageable;
    const params = {
      search: filters.search,
      page,
      size: rowsPerPage,
      sort: sortBy && sortDir ? `${sortBy},${sortDir}` : undefined,
    };
    const response = await backend.post("/apts/mp/select/perregion", request, {
      params,
    });
    return response.data;
  }

  async getSelectSupplyPyeongInfo(request, pageable) {
    const { filters, page, rowsPerPage, sortBy, sortDir } = pageable;
    const params = {
      search: filters.search,
      page,
      size: rowsPerPage,
      sort: sortBy && sortDir ? `${sortBy},${sortDir}` : undefined,
    };
    const response = await backend.post("/apts/sp/select", request, {
      params,
    });
    return response.data;
  }

  /** 평형 필터 안에서 30평과 가장 가까운 공급평형을 아파트별로 하나 조회한다. */
  async getSelectRepresentativeSupplyPyeongInfo(request, pageable) {
    const { filters, page, rowsPerPage, sortBy, sortDir } = pageable;
    const params = {
      search: filters?.search,
      page,
      size: rowsPerPage,
      sort: sortBy && sortDir ? `${sortBy},${sortDir}` : undefined,
    };
    const response = await backend.post("/apts/sp/select/representative", request, {
      params,
    });
    return response.data;
  }

  async getSelectSupplyPyeongMapInfo(request, pageable) {
    const { filters, page, rowsPerPage, sortBy, sortDir } = pageable;
    const params = {
      search: filters.search,
      page,
      size: rowsPerPage,
      sort: sortBy && sortDir ? `${sortBy},${sortDir}` : undefined,
    };
    console.log("request: %O, pageable: %O", request, pageable);
    const response = await backend.post("/apts/sp/select/map", request, {
      params,
    });
    return response.data;
  }

  async getSelectSupplyPyeongInfoPerRegion(request, pageable) {
    const { filters, page, rowsPerPage, sortBy, sortDir } = pageable;
    const params = {
      search: filters.search,
      page,
      size: rowsPerPage,
      sort: sortBy && sortDir ? `${sortBy},${sortDir}` : undefined,
    };
    const response = await backend.post("/apts/sp/select/perregion", request, {
      params,
    });
    return response.data;
  }

  async getNormalAptInfo(request, pageable) {
    const { filters, page, rowsPerPage, sortBy, sortDir } = pageable;
    const params = {
      search: filters.search,
      page,
      size: rowsPerPage,
      sort: sortBy && sortDir ? `${sortBy},${sortDir}` : undefined,
    };
    console.log("normal apt params: %O", params);
    const response = await backend.post("/apts/normal", request, { params });
    return response.data;
  }

  async getRangeAptInfo(request, pageable) {
    const { filters, page, rowsPerPage, sortBy, sortDir } = pageable;
    const params = {
      search: filters.search,
      page,
      size: rowsPerPage,
      sort: sortBy && sortDir ? `${sortBy},${sortDir}` : undefined,
    };
    const response = await backend.post(freeScreenScope() === "apartment" ? `/free/apartments/${new URLSearchParams(window.location.search).get("id")}/neighbors` : "/apts/range", request, { params });
    return response.data;
  }

  async getDefaultAptInfo(request, pageable) {
    const { filters, page, rowsPerPage, sortBy, sortDir } = pageable;
    const params = {
      search: filters.search,
      page,
      size: rowsPerPage,
      sort: sortBy && sortDir ? `${sortBy},${sortDir}` : undefined,
    };
    const response = await backend.post("/apts/default", request, { params });
    return response.data;
  }

  async getInvestmentAptInfo(request, pageable) {
    const { filters, page, rowsPerPage, sortBy, sortDir } = pageable;
    const params = {
      search: filters.search,
      page,
      size: rowsPerPage,
      sort: sortBy && sortDir ? `${sortBy},${sortDir}` : undefined,
    };
    const response = await backend.post("/apts/investment", request, {
      params,
    });
    return response.data;
  }

  async getSPyeongPriceDto(request, pageable) {
    const { filters, page, rowsPerPage, sortBy, sortDir } = pageable;
    const params = {
      search: filters.search,
      page,
      size: rowsPerPage,
      sort: sortBy && sortDir ? `${sortBy},${sortDir}` : undefined,
    };
    const response = await backend.post("/apts/spyeong/price", request, {
      params,
    });
    return response.data;
  }

  async getSPyeongPriceDtoPerRegion(request, pageable) {
    const { filters, page, rowsPerPage, sortBy, sortDir } = pageable;
    const params = {
      search: filters.search,
      page,
      size: rowsPerPage,
      sort: sortBy && sortDir ? `${sortBy},${sortDir}` : undefined,
    };
    const response = await backend.post(
      "/apts/spyeong/price/perregion",
      request,
      { params },
    );
    return response.data;
  }

  async getSPyeongPriceDtoByIds(ids, pageable) {
    const { page, rowsPerPage, sortBy, sortDir } = pageable;
    const params = {
      page,
      size: rowsPerPage,
      sort: sortBy && sortDir ? `${sortBy},${sortDir}` : undefined,
    };
    const response = await backend.post(
      "/apts/spyeong/price/ids",
      { ids },
      { params },
    );
    return response.data;
  }

  async searchApts(query, pageable = { page: 0, rowsPerPage: 20 }) {
    const { page, rowsPerPage } = pageable;
    const params = {
      page,
      size: rowsPerPage,
    };
    const response = await backend.post("/apts/search", { query }, { params });
    return response.data;
  }

  /** 시도별 대장아파트 조회 (평당가 1위, 30평↑ 500세대↑) */
  async getTopBySido(params = {}) {
    const response = await backend.get("/apts/top-by-sido", { params });
    return response.data;
  }

  async searchSupplyPyeongs(query, pageable = { page: 0, rowsPerPage: 20 }) {
    const { page, rowsPerPage } = pageable;
    const params = {
      page,
      size: rowsPerPage,
    };
    const response = await backend.post(
      "/apts/sp/search",
      { query },
      { params },
    );
    return response.data;
  }
}

export const aptApi = new AptApi();
